import React from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';


const SweetAlert = ({ show, onHide, title, subtitle, icon, confirmButtonText, cancelButtonText, showCancelButton, onConfirm, onCancel, loadSubmit }) => {
    return <Modal show={show} onHide={onHide} backdrop="static" centered>
        <Modal.Body className="text-center" style={{ padding: '2rem 1.5rem' }}>
            <h2 style={{ color: '#201030', fontSize: '1.25rem' }}><strong>{title}</strong></h2>
            <p style={{ color: '#6B7280' }}>{subtitle}</p>
            <div className="d-flex justify-content-center" style={{ gap: 8, flexWrap: 'wrap' }}>
                <Button variant={`danger${showCancelButton ? '' : ''}`} onClick={onConfirm} style={{ borderRadius: 12, minWidth: 120 }}>
                    {loadSubmit ? <i className="fa fa-circle-notch fa-spin"></i> : confirmButtonText}
                </Button>
                {showCancelButton ? <Button variant="secondary" onClick={onCancel} style={{ borderRadius: 12, minWidth: 100 }}>{cancelButtonText}</Button> : ''}
            </div>
        </Modal.Body>
    </Modal>
}

SweetAlert.defaultProps = {
    title: '',
    subtitle: '',
    icon: '',
    show: false,
    onHide: () => {},
    onConfirm: () => {},
    confirmButtonText: '',
    onCancel: () => {},
    cancelButtonText: '',
    showCancelButton: true,
    loadSubmit: false
}

export default SweetAlert;
